import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchSimProductEntry } from 'products/sim/SimProductsApi/simProductsApi';
import { simProductQueries } from '../queries/simProductsQueries';

export const useSimProductDetails = (iccid: string) => {
  return useSuspenseQuery({
    queryKey: simProductQueries.detail({ iccid }),
    queryFn: () => (iccid ? fetchSimProductEntry(iccid) : null),
    refetchOnWindowFocus: false,
  });
};
